import React, { useEffect, useState } from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  Row,
  Col,
  Input,
  Button
} from 'reactstrap';
import WeekdaySelector from '../../../../../components/Inputs/WeekDaySelector';

const PauseModal = ({
  isOpen,
  toggle,
  pauses,
  pauseOptions,
  onSave,
  editPause,
  editIndex
}) => {
  const [selectedPause, setSelectedPause] = useState(
    pauses && pauses.length > 0
      ? {
          pauseName: pauses[0].label,
          pauseValue: pauses[0].value
        }
      : null
  );
  const [reference, setReference] = useState('ENTRY');
  const [interval, setInterval] = useState(0);
  const [duration, setDuration] = useState(1);
  const [toleranceTime, setToleranceTime] = useState(0);
  const [enableUnpauseCheck, setEnableUnpauseCheck] = useState(false);
  const [selectedDays, setSelectedDays] = useState({
    sun: false,
    mon: false,
    tue: false,
    wed: false,
    thu: false,
    fri: false,
    sat: false
  });

  useEffect(() => {
    if (pauses.length > 0) {
      setSelectedPause({
        pauseName: pauses[0].label,
        pauseValue: pauses[0].value
      });
    }
  }, [pauses]);

  useEffect(() => {
    if (!isOpen) return;

    if (editPause) {
      const pauseId = editPause.pauseId || editPause.pause?.id;
      const pauseName = editPause.pause?.name || editPause.pauseName;

      setSelectedPause({
        pauseName,
        pauseValue: pauseId
      });

      setReference(editPause.intervalReference || 'ENTRY');
      setInterval(editPause.triggerInterval ?? 0);
      setDuration(editPause.duration ?? 1);
      setToleranceTime(editPause.toleranceTime ?? 0);
      setEnableUnpauseCheck(!!editPause.enableUnpauseCheck);

      setSelectedDays({
        sun: !!editPause.sunday,
        mon: !!editPause.monday,
        tue: !!editPause.tuesday,
        wed: !!editPause.wednesday,
        thu: !!editPause.thursday,
        fri: !!editPause.friday,
        sat: !!editPause.saturday
      });
    } else {
      const defaultPause = pauses[0];
      setSelectedPause(
        defaultPause
          ? {
              pauseName: defaultPause.label,
              pauseValue: defaultPause.value
            }
          : null
      );
      setReference('ENTRY');
      setInterval(0);
      setDuration(1);
      setToleranceTime(0);
      setEnableUnpauseCheck(false);
      setSelectedDays({
        sun: false,
        mon: false,
        tue: false,
        wed: false,
        thu: false,
        fri: false,
        sat: false
      });
    }
  }, [isOpen, editPause, pauses]);
  const handleDaysChange = (days) => {
    setSelectedDays(days);
  };

  const handleSave = () => {
    const newPause = {
      pauseId: selectedPause?.pauseValue,
      pauseName: selectedPause?.pauseName,
      intervalReference: reference,
      triggerInterval: Number(interval),
      duration: Number(duration),
      enableUnpauseCheck: enableUnpauseCheck,
      toleranceTime: Number(toleranceTime),
      monday: selectedDays.mon,
      tuesday: selectedDays.tue,
      wednesday: selectedDays.wed,
      thursday: selectedDays.thu,
      friday: selectedDays.fri,
      saturday: selectedDays.sat,
      sunday: selectedDays.sun
    };

    if (editIndex !== null && editIndex >= 0) {
      onSave(newPause, editIndex);
    } else {
      onSave(newPause);
    }
    toggle();
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered={true}>
      <ModalHeader toggle={toggle}>
        {editIndex !== null
          ? 'Editar Pausa Automática'
          : 'Adicionar Pausa Automática'}
      </ModalHeader>
      <ModalBody>
        <Row>
          <Col md="12">
            <h5>Pausa</h5>
            <Input
              type="select"
              name="pauseId"
              value={selectedPause?.pauseValue || ''}
              onChange={(e) => {
                const selected = pauses.find(
                  (p) => p.value === Number(e.target.value)
                );
                if (selected) {
                  setSelectedPause({
                    pauseName: selected.label,
                    pauseValue: selected.value
                  });
                }
              }}
            >
              {pauses.map((pause) => (
                <option key={pause.value} value={pause.value}>
                  {pause.label}
                </option>
              ))}
            </Input>
          </Col>
        </Row>
        <Row style={{ marginTop: '1rem' }}>
          <Col md="8">
            <h5>Referência</h5>
            <Input
              type="select"
              name="intervalReference"
              value={reference}
              onChange={(e) => {
                setReference(e.target.value);
              }}
            >
              {pauseOptions.map((pause, index) => {
                return (
                  <option key={index} value={pause.value}>
                    {pause.label}
                  </option>
                );
              })}
            </Input>
          </Col>
        </Row>
        <Row style={{ marginTop: '1rem' }}>
          <Col md="12">
            <h5>Intervalo para acionamento(Minutos)</h5>
            <Input
              type="number"
              name="intervalReference"
              onChange={(e) => setInterval(e.target.value)}
              value={interval}
              min={0}
            />
          </Col>
        </Row>
        <Row style={{ marginTop: '1rem' }}>
          <Col md="12">
            <h5>Duração(Minutos)</h5>
            <Input
              type="number"
              name="duration"
              onChange={(e) => setDuration(e.target.value)}
              value={duration}
              min={1}
            />
          </Col>
        </Row>
        <Row style={{ marginTop: '1rem' }}>
          <Col md="12">
            <label className="form-control-label">
              Tempo de Tolerância* (Segundos)
            </label>
            <Input
              type="number"
              disabled={!enableUnpauseCheck}
              name="toleranceTime"
              onChange={(e) => setToleranceTime(e.target.value)}
              value={toleranceTime}
              defaultValue={0}
              min={0}
            />
          </Col>
        </Row>

        <Row style={{ marginTop: '1rem' }}>
          <Col md="12">
            <WeekdaySelector onChange={handleDaysChange} value={selectedDays} />
          </Col>
        </Row>

        <Row className="ml-1">
          <Col md="12">
            <label className="form-control-label">
              <Input
                type="checkbox"
                onChange={(e) => {
                  setEnableUnpauseCheck(e.target.checked);
                  setToleranceTime(0);
                }}
                checked={enableUnpauseCheck}
              />
              Habilitar bloqueio da remoção da pausa após horario
            </label>
          </Col>
        </Row>
        <Row className="mt-3 ml-1">
          <Button color="primary" onClick={handleSave}>
            Salvar
          </Button>

          <Button color="secondary" onClick={toggle}>
            Cancelar
          </Button>
        </Row>
      </ModalBody>
    </Modal>
  );
};

export default PauseModal;
